module.exports = __webpack_public_path__ + "media/applicants/requires-car-ad4f28bd.svg";